module.exports = __webpack_public_path__ + "img/avatar3.ba9929b2.png";